import React from "react";
import Octicon, { Location } from "@primer/octicons-react";

const Contact = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-8 mb-5">
          <h2>
            <Octicon icon={Location} className="mr-2" size="medium" />
            Jak do nas dojechać
          </h2>
          <hr />
          <iframe
            title="mapka"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2420.3907604651577!2d19.117625452064296!3d52.65291917974067!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471c9bb6f8b74b6b%3A0x38a59413c1c2ad8c!2sDuninowska%202%2C%2087-806%20W%C5%82oc%C5%82awek!5e0!3m2!1sen!2spl!4v1578007130235!5m2!1sen!2spl"
            width="100%"
            height="550"
            style={{ border: "1px solid #CCC" }}
            frameborder="0"
            allowfullscreen=""
          ></iframe>
        </div>
        <div className="col-md-4 mb-5">
          <h2>Kontakt</h2>
          <hr />
          <address>
            ul. Duninowska 2
            <br />
            87-806 Włocławek
            <br />
          </address>
          <address>
            <abbr title="Phone">Telefon:</abbr>
            600 762 522
            <br />
            <abbr title="Email">Email:</abbr>
            <a href="mailto:czereba@o2.pl">czereba@o2.pl</a>
          </address>
        </div>
      </div>
    </div>
  );
};

export default Contact;
